import setupDeprecationWorkflow from 'ember-cli-deprecation-workflow';

// Only deprecations still emitted by the installed packages belong here.
// Everything else was removed in Ember 4.0 and can never fire, so a stale
// entry just hides a future regression from `throwOnUnhandled`.
// `throwOnUnhandled` has to live inside this call: the addon only reads it
// off the config object passed to `setupDeprecationWorkflow`. Assigning to
// `window.deprecationWorkflow.config` afterwards is a no-op.
setupDeprecationWorkflow({
  throwOnUnhandled: true,
  workflow: [
    // Enabled in ember-source 6.3. ember-in-viewport still
    // `import { inject } from '@ember/service'` and is on its final release,
    // so there is no version of it left to upgrade to.
    { handler: 'silence', matchId: 'importing-inject-from-ember-service' },

    // Enabled in ember-source 6.5, removed in 7.0. Reads of the `ember`
    // barrel proxy from dependency code only -- we import nothing from
    // `ember` ourselves, so these are listed one id at a time rather than
    // silenced as a family: a barrel import in our own code should still
    // throw. `libraries` is ember-data 4.12's registerCoreLibrary call.
    { handler: 'silence', matchId: 'deprecate-import-libraries-from-ember' },
    {
      handler: 'silence',
      matchId: 'deprecate-import-change-properties-from-ember',
    },
    { handler: 'silence', matchId: 'deprecate-import-test-from-ember' },
    { handler: 'silence', matchId: 'deprecate-import-meta-from-ember' },
    // `__loader` dasherizes to `--loader`, hence the triple dash. Read by
    // @nullvoxpopuli/ember-composable-helpers' -private/closure-action.js, plus
    // the ember-destroyable-polyfill and ember-modifier-manager-polyfill vendor
    // shims.
    { handler: 'silence', matchId: 'deprecate-import---loader-from-ember' },

    // Enabled in ember-data 5.8, removed in warp-drive 6.0. The app still uses
    // the classic request pipeline: app/adapters/*, app/serializers/* extending
    // FragmentRESTSerializer, and store.query/createRecord. Moving off
    // adapters/serializers means moving off ember-data-model-fragments, since
    // its FragmentStore cannot compose with useLegacyStore. Silence until that
    // migration lands, then drop this entry and ENABLE_LEGACY_REQUEST_METHODS
    // from ember-cli-build.js together.
    {
      handler: 'silence',
      matchId: 'warp-drive:deprecate-legacy-request-methods',
    },

    // Enabled in ember-data 5.4, removed in 6.0. ember-data-model-fragments
    // @9.0.0 reaches for the legacy schema service
    // (getSchemaDefinitionService().attributesDefinitionFor) in 17 places
    // across its cache/ and array/ code, which is why
    // ENABLE_LEGACY_SCHEMA_SERVICE is on in ember-cli-build.js. Silence until
    // the fragments migration; drop both together.
    { handler: 'silence', matchId: 'ember-data:schema-service-updates' },

    // Enabled in ember-source 7.2, removed in 7.5. ember-data-model-fragments
    // @9.0.0 defines its base class as `Model.extend(Comparable, {...})`, so
    // every fragment instance fires this from Comparable's init. Fragment
    // already implements `compare` itself; the mixin is vestigial. Must be
    // fixed (patch or migration) before ember-source 7.5, which drops the
    // `Comparable` export and breaks the import outright.
    { handler: 'silence', matchId: 'deprecate-comparable-mixin' },

    // Enabled in ember-data 5.2, removed in 6.0. ember-data auto-installs the
    // built-in transforms (string/number/boolean/date) and a store service via
    // its own app/ tree; each is a thin subclass that only adds this deprecate()
    // call, so they still work exactly as before. We keep using them rather than
    // re-exporting our own: an addon app/ tree merges at the same precedence as
    // ember-data's and loses, so overriding would mean a copy in every app.
    // This id covers only those four transforms and app/services/store.js, and
    // both apps already supply their own store via linced-common's FragmentStore.
    { handler: 'silence', matchId: 'ember-data:deprecate-legacy-imports' },
  ],
});
